import { render, staticRenderFns } from "./GameInfos.vue?vue&type=template&id=6dbb972b&scoped=true"
import script from "./GameInfos.vue?vue&type=script&lang=js"
export * from "./GameInfos.vue?vue&type=script&lang=js"
import style0 from "./GameInfos.vue?vue&type=style&index=0&id=6dbb972b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb972b",
  null
  
)

export default component.exports